import React from 'react';
import { connect } from 'react-redux';
import { getLanguage } from '../../../store/selectors';
import { StoreState } from '../../../util/types';
import styled from 'styled-components';

import { en } from './tutorial/en';
import { vi } from './tutorial/vi';
import { jp } from './tutorial/jp';
const I18n = require('i18n-js');

interface Props {
    language: string
}
const Wrap = styled.div`
    margin: 20px 5%;
    text-align: left;
    color: ${props => props.theme.componentsTheme.textColorCommon};
`
const Title = styled.h1`
    text-align: center;
`
const Faqs = styled.div``
const Head = styled.h3``
const Question = styled.h3``
const Answer = styled.p``
// const Img = styled.img``

class _App extends React.Component<Props> {

    public render = () => {
        let lang = en;
        switch (this.props.language) {
            case 'ja':
                lang = jp;
                break;
            case 'vi':
                lang = vi;
                break;
        }
        return (
            <Wrap>
                <Title>{I18n.t('dexTutorial')}</Title>
                {lang}
            </Wrap>

        );
    };
}

const mapStateToProps = (state: StoreState): Props => {
    return {
        language: getLanguage(state)
    };
};

const App = connect(
    mapStateToProps,
    null,
)(_App);
export default App;
